import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { postCadastroMaquinario, getLinhas } from '../../../slices/productSlice';
import ButtonGlobal from '../../../components/ButtonGlobal';
import SelectGlobal from '../../../components/SelectGlobal';
import { resetProduct } from '../../../slices/productSlice';
import Title from '../../../components/Title';
import InputGlobal from '../../../components/InputGlobal';
import Main from '../../../components/Main/Main';
import MsgSucess from '../../../components/MsgSucess';
import { useErroControlManul } from '../../../hook/useErroControlManul';
import Form from '../../../components/Main/Form';
import usePageTitle from '../../../hook/usePageTitle';

// document.title = 'Cadastro | Maquinario';

const Equipamento = () => {
  usePageTitle();

  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    control,
    setError,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { loading, error, linhas, success } = useSelector((state) => state.product);
  const { useArrayErrorForm } = useErroControlManul();
  const nomeWatch = watch('nome');

  useEffect(() => {
    dispatch(getLinhas());
  }, []);

  useEffect(() => {
    if (error) {
      useArrayErrorForm(error, setError);
    }
    return () => clearErrors();
  }, [setError, error]);

  const resetInfo = () => {
    reset();
    dispatch(resetProduct());
  };

  const onSubmit = (data) => {
    dispatch(postCadastroMaquinario(data));
  };

  return (
    <Main>
      <Title>Cadastrar Maquinario</Title>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-[90%] sm:w-1/2">
          <InputGlobal
            type="text"
            label="Tag"
            formCamp="tag"
            placeholder="Digite uma Tag"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.tag ? errors : false}
          />
          <InputGlobal
            type="text"
            label="nome"
            formCamp={'nome'}
            placeholder="Digite um Nome"
            required={true}
            register={register}
            validations={{ required: true }}
            error={!!errors?.nome}
            errors={errors?.nome ? errors : false}
          />
          <SelectGlobal
            formCamp="linha"
            label="Linha"
            array={linhas}
            required
            register={register}
            validations={{ required: true }}
            errors={!!errors.linha ? errors : false}
            control={control}
          />
        </div>
        <div className="m-auto ">
          <ButtonGlobal
            text="Cadastrar"
            click={handleSubmit(onSubmit)}
            error={Object.keys(errors).length > 0 ? true : false}
          />
        </div>
        {success && <MsgSucess text={nomeWatch} reset={resetInfo} />}
      </Form>
    </Main>
  );
};

export default Equipamento;
